<template>
  <div>
    <validation-observer ref="registerRKIDebtorRules">
      <b-form>
        <b-row>
          <b-col
            sm="12"
          >
            <p class="text-center">
              Debtor will be register in RKI
            </p>
          </b-col>
          <b-col
            cols="12"
          >
            <b-button
              variant="primary"
              type="submit"
              class="addAwaitBtn"
              @click.prevent="submitForm"
            >
              {{ $t('DEBTIA_SUBMIT') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import {
  // BFormInput,
  BButton,
  BForm,
  BRow,
  BCol,
  // BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    ValidationObserver,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      courtsOptions: [],
    }
  },
  methods: {
    async submitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 20,
        module_order: 1,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      await this.$refs.registerRKIDebtorRules.validate().then(success => {
        if (success) {
          const url = '/process/module/add'
          axios.post(url, dataObj).then(response => {
            if (response.status === 200) {
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeRegisterRKIModal', returnObj)
            }
          }).catch(e => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: e.response.data.message[0],
              },
            })
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
